module.exports = __webpack_public_path__ + "img/mrBts_concept_thumb.a1742c58.jpg";